<template>
  <div class="loading">
    <div class="container">
      <div class="row justify-content-center align-items-center loading">
        Cargando...
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loading',
  };
</script>

<style>
  .loading{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?be6f16e6